import Hive from './Hive';

export default Hive;
